import { defineStore } from 'pinia'

// Vendor readiness ile ilgili sabit rotalar
export const VENDOR_ONBOARDING_ROUTE = '/management/eksikler'
export const SAFE_ONBOARDING_ROUTES = [
  VENDOR_ONBOARDING_ROUTE,
  '/management/magazam/ayarlar',
  '/management/magazam/ayarlar/banka-ayarlari',
  '/management/magazam/adresler',
  '/management/login'
]

const CACHE_TTL_MS = 5 * 60 * 1000 // Hazırlık bilgisini 5 dakika cache'liyoruz

export const useVendorStore = defineStore('vendorStore', () => {
  const { API_ENDPOINTS } = useApiEndpoints()

  const readiness = ref(null)
  const lastCheckedAt = ref(0)
  const loading = ref(false)

  const isReady = computed(() => readiness.value?.is_ready === true)
  const missingRequirements = computed(
    () => readiness.value?.missing_requirements || []
  )
  const requirements = computed(() => readiness.value?.requirements || [])
  const completedCount = computed(
    () => requirements.value.filter((item) => item.completed).length
  )
  const pendingCount = computed(
    () => requirements.value.filter((item) => !item.completed).length
  )

  const shouldRefresh = computed(() => {
    if (!lastCheckedAt.value) return true
    return Date.now() - lastCheckedAt.value > CACHE_TTL_MS
  })

  /**
   * Vendor hazır mı bilgisini getirir; 5 dk cache uygular.
   */
  const fetchReadiness = async ({ force = false } = {}) => {
    if (!force && !shouldRefresh.value && readiness.value) {
      return readiness.value
    }

    loading.value = true
    try {
      const response = await useBaseOFetchWithAuth(
        API_ENDPOINTS.protected.vendor.readiness
      )
      readiness.value = response?.data ?? null
      lastCheckedAt.value = Date.now()
      return readiness.value
    } finally {
      loading.value = false
    }
  }

  /**
   * Yeni istek zorlamak için cache damgasını sıfırlar.
   */
  const markStale = () => {
    lastCheckedAt.value = 0
  }

  return {
    readiness,
    loading,
    lastCheckedAt,
    isReady,
    missingRequirements,
    requirements,
    completedCount,
    pendingCount,
    fetchReadiness,
    markStale
  }
})
